import { render } from "./App.pug?vue&type=template&id=0a3cf2ca&lang=pug"
import script from "./App.js?vue&type=script&lang=js"
export * from "./App.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__